import styles from "./Sidebar.module.scss"

import React from "react"
import { useParams } from "react-router-dom"

import { WOWNET_CONTENT } from "@shared/constants"
import { ChatProvider, MessageSenderProvider } from "@shared/contexts"

import classNames from "classnames"
import { useIsSidebarEnabled } from "live/contexts"

import { Contents } from "./contents"

function Sidebar() {
  const { streamerName } = useParams<{ streamerName?: string }>()
  const isSidebarEnabled = useIsSidebarEnabled()

  if (!isSidebarEnabled) {
    return null
  }

  return (
    <article className="sideB">
      <div className={classNames("iframeB", styles.sidebarSize)}>
        <iframe
          title="프로필"
          className={styles.sidebarSize}
          src={`${WOWNET_CONTENT.aside}?analid=${streamerName}`}
        />
      </div>
      <ChatProvider>
        <MessageSenderProvider>
          <Contents />
        </MessageSenderProvider>
      </ChatProvider>
    </article>
  )
}

export default Sidebar
